import React, { PureComponent } from 'react';
import PLUS_ICON from 'assets/img/plus.svg';
import PLUS_ICON_DARK from 'assets/img/black/plus.svg';
import PLACE_ICON from 'assets/img/pin_blue.svg';
import FIBER_ICON from 'assets/img/fiber.svg';
import TRUCK_ICON from 'assets/img/truck.svg';
import SPEED_ICON from 'assets/img/speed.svg';
import CIRCLE_ICON from 'assets/img/circle.svg';
import BROADBAND_ICON from 'assets/img/broadband.svg';
import OVERRIDE from 'assets/img/ok.svg';
import FIBER_ICON_DARK from 'assets/img/black/fiber.svg';
import TRUCK_ICON_DARK from 'assets/img/black/truck.svg';
import SPEED_ICON_DARK from 'assets/img/black/speed.svg';
import CIRCLE_ICON_DARK from 'assets/img/black/circle.svg';
import BROADBAND_ICON_DARK from 'assets/img/black/broadband.svg';
import CUSTOMIZE from 'assets/img/black/wrench.svg';
import {
  RoundChart,
  Map,
} from 'view/common';
import './style.scss';
import { connect } from 'react-redux';

const ImageWithText = ({ src, text }) => (
  <div className="addressView_tag">
    <img src={src} alt="icon" style={{ height: '18px', width: '18px' }} />
    <p>{text}</p>
  </div>
);

const TileView = ({
  address, toggleShowDetail, isOverriden, isCustomized, isDarkTheme,
}) => (
  <React.Fragment>
    <Map
      style={{
        width: '100%',
        height: '200px',
      }}
      markerPosition={{ lat: -34.397, lng: 150.644 }}
      isOverriden={isOverriden}
    />
    <div className="addressView_header">
      <div className="addressView_header_text">
        <img src={isOverriden ? OVERRIDE : PLACE_ICON} alt="place" />
        <h2>{address}</h2>
      </div>
      <div
        className="addressView_header_details"
        onClick={() => toggleShowDetail({ isOverriden })}
      >
        <img src={isDarkTheme ? PLUS_ICON_DARK : PLUS_ICON} alt="plus" />
        View details
      </div>
    </div>
    <div className="addressView_column">
      <div className="addressView_column_cell">
        <div className="addressView_row">
          <div className="addressView_chart_wrapper">
            <RoundChart
              color="blue"
              percent={35}
              title="CONFIDENCE"
              heidht="121px"
              width="121px"
              titleStyle={{ fontSize: '14px' }}
              percentStyle={{ fontSize: '16px' }}
            />
          </div>
          <div className="addressView_statistic">
            <div className="addressView_statistic_title">
              <p>First Choice: </p>
              <p>AT&T</p>
            </div>
            <div className="addressView_tag_row">
              <ImageWithText src={isDarkTheme ? FIBER_ICON_DARK : FIBER_ICON} text="Fiber" />
              <ImageWithText src={isDarkTheme ? TRUCK_ICON_DARK : TRUCK_ICON} text="Carrier" />
            </div>
            <div className="addressView_tag_row">
              <ImageWithText src={isDarkTheme ? SPEED_ICON_DARK : SPEED_ICON} text="100 mbsp" />
              <ImageWithText src={isDarkTheme ? CIRCLE_ICON_DARK : CIRCLE_ICON} text="On-Net" />
            </div>
          </div>
          {isCustomized && (
          <img
            src={CUSTOMIZE}
            style={{
              margin: '42px 14px auto 0', height: '14px', width: '14px',
            }}
            alt="customize icon"
          />
          )}
        </div>
      </div>
      <div className="addressView_column_cell">
        <div className="addressView_row">
          <div className="addressView_chart_wrapper">
            <RoundChart
              color="blue"
              percent={35}
              title="CONFIDENCE"
              heidht="121px"
              width="121px"
              titleStyle={{ fontSize: '14px' }}
              percentStyle={{ fontSize: '16px' }}
            />
          </div>
          <div className="addressView_statistic">
            <div className="addressView_statistic_title">
              <p>Second Choice: </p>
              <p>Verizon</p>
            </div>
            <div className="addressView_tag_row">
              <ImageWithText src={isDarkTheme ? BROADBAND_ICON_DARK : BROADBAND_ICON} text="Broadband" />
              <ImageWithText src={isDarkTheme ? TRUCK_ICON_DARK : TRUCK_ICON} text="Carrier" />
            </div>
            <div className="addressView_tag_row">
              <ImageWithText src={isDarkTheme ? SPEED_ICON_DARK : SPEED_ICON} text="100 mbsp" />
              <ImageWithText src={isDarkTheme ? CIRCLE_ICON_DARK : CIRCLE_ICON} text="On-Net" />
            </div>
          </div>
          {isCustomized && (
          <img
            src={CUSTOMIZE}
            style={{
              margin: '42px 14px auto 0', height: '14px', width: '14px',
            }}
            alt="customize icon"
          />
          )}
        </div>
      </div>
    </div>
  </React.Fragment>
);

const InlineView = ({
  address, toggleShowDetail, isOverriden, isCustomized, isDarkTheme,
}) => (
  <React.Fragment>
    <div className="addressView_header">
      <div className="addressView_header_text">
        <img src={isOverriden ? OVERRIDE : PLACE_ICON} alt="place" />
        <h2>{address}</h2>
      </div>
      <div
        className="addressView_header_details"
        onClick={() => toggleShowDetail({ isOverriden })}
      >
        <img src={isDarkTheme ? PLUS_ICON_DARK : PLUS_ICON} alt="plus" />
        View details
      </div>
    </div>
    <div className="addressView_row">
      <div className="addressView_cell">
        <div className="addressView_row">
          <div className="addressView_chart_wrapper">
            <RoundChart
              color="blue"
              percent={35}
              title="CONFIDENCE"
              heidht="121px"
              width="121px"
              titleStyle={{ fontSize: '14px' }}
              percentStyle={{ fontSize: '16px' }}
            />
          </div>
          <div className="addressView_statistic">
            <div className="addressView_statistic_title">
              <p>First Choice: </p>
              <p>AT&T</p>
            </div>
            <div className="addressView_tag_row">
              <ImageWithText src={isDarkTheme ? FIBER_ICON_DARK : FIBER_ICON} text="Fiber" />
              <ImageWithText src={isDarkTheme ? TRUCK_ICON_DARK : TRUCK_ICON} text="Carrier" />
            </div>
            <div className="addressView_tag_row">
              <ImageWithText src={isDarkTheme ? SPEED_ICON_DARK : SPEED_ICON} text="100 mbsp" />
              <ImageWithText src={isDarkTheme ? CIRCLE_ICON_DARK : CIRCLE_ICON} text="On-Net" />
            </div>
          </div>
          {isCustomized && (
          <img
            src={CUSTOMIZE}
            style={{
              marginBottom: 'auto', height: '14px', width: '14px', marginTop: '42px',
            }}
            alt="customize icon"
          />
          )}
        </div>
      </div>
      <div className="addressView_cell">
        <div className="addressView_row">
          <RoundChart
            color="blue"
            percent={35}
            title="CONFIDENCE"
            heidht="121px"
            width="121px"
            titleStyle={{ fontSize: '14px' }}
            percentStyle={{ fontSize: '16px' }}
          />
          <div className="addressView_statistic">
            <div className="addressView_statistic_title">
              <p>Second Choice: </p>
              <p>Verizon</p>
            </div>
            <div className="addressView_tag_row">
              <ImageWithText src={isDarkTheme ? BROADBAND_ICON_DARK : BROADBAND_ICON} text="Broadband" />
              <ImageWithText src={isDarkTheme ? TRUCK_ICON_DARK : TRUCK_ICON} text="Carrier" />
            </div>
            <div className="addressView_tag_row">
              <ImageWithText src={isDarkTheme ? SPEED_ICON_DARK : SPEED_ICON} text="100 mbsp" />
              <ImageWithText src={isDarkTheme ? CIRCLE_ICON_DARK : CIRCLE_ICON} text="On-Net" />
            </div>
          </div>
          {isCustomized && (
          <img
            src={CUSTOMIZE}
            style={{
              marginBottom: 'auto', height: '14px', width: '14px', marginTop: '42px',
            }}
            alt="customize icon"
          />
          )}
        </div>
      </div>
    </div>
  </React.Fragment>
);

class AddressView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      address: '123 C St. Corona,  92883, CA',
    };
  }

  render() {
    const {
      isTileView, toggleShowDetail, isOverriden = false, isCustomized = false, isDarkTheme,
    } = this.props;
    const { address } = this.state;
    return (
      <div className="addressView" style={{ width: isTileView ? '48%' : '100%' }}>
        {isTileView
          ? (
            <TileView
              address={address}
              toggleShowDetail={toggleShowDetail}
              isOverriden={isOverriden}
              isDarkTheme={isDarkTheme}
              isCustomized={isCustomized}
            />
          )
          : (
            <InlineView
              address={address}
              toggleShowDetail={toggleShowDetail}
              isOverriden={isOverriden}
              isCustomized={isCustomized}
              isDarkTheme={isDarkTheme}
            />
          )
        }
      </div>
    );
  }
}
const mapStateToProps = state => ({
  isDarkTheme: state.app.isDarkTheme,
});

const AddressViewConnected = connect(mapStateToProps)(AddressView);

export { AddressViewConnected as AddressView };



// WEBPACK FOOTER //
// ./src/view/common/AddressView/index.jsx